module.exports = __webpack_public_path__ + "img/mazer-screens.95c7255c.png";